$(document).ready(function () {

    const ajaxPathGetInventoryCountProductsTableHtml = '/action/report/inventory-count-products-table';
    const ajaxPathGetInventoryCountListHtml = '/action/report/inventory-count-list';

    var modalParentElementInDOM = $('div#content');
    var modalTitle = '';
    var modalMessage = '';
    var modalButtonText = 'Lukk';
    var modalAlertType = '';
    let selectedInventoryCountId = 0;

    function refreshList() {
        let year = $('select#filter_by_year option:selected').attr('value');
        const name = $('#inventory_search_input').val();

        const data = {
            year: year
        }

        if(name) {
            data.name = name.toLowerCase();
        }

        $.ajax({
            type: 'GET',
            url: ajaxPathGetInventoryCountListHtml,
            data: data,
            dataType: 'json'
        }).success(function (data) {
            $('div#inventory_list_wrapper div#inventory_count_select_wrapper').replaceWith(data.html);
            $('div#inventory_count_wrapper div#selected_inventory_count_wrapper').html('');
            selectedInventoryCountId = 0;

        }).error(function (data) {
            modalTitle = 'Det oppstod en feil!';
            modalMessage = $.parseJSON(data.responseText).errors;
            modalAlertType = 'error';

            displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
        });
    }

    $(document).on('click', 'div#inventory_list_wrapper .inventory_count_list_item', function(e) {
        e.preventDefault();

        let inventoryCountId = parseInt($(this).attr('inventory_count_id'), 10) || 0;
        if (!inventoryCountId) {
            return false;
        }

        selectedInventoryCountId = inventoryCountId;

        if (typeof setActiveListItem === 'function') {
            setActiveListItem('div#inventory_count_list_container .list-group-item', inventoryCountId, 'inventory_count_id');
        }

        const includeProductGroups = $('div#inventory_list_wrapper input#inventory_count_by_product_group').is(':checked');

        $.ajax({
            type: 'GET',
            url: ajaxPathGetInventoryCountProductsTableHtml,
            data: {
                inventory_count_id: inventoryCountId,
                include_product_groups: includeProductGroups ? 1 : 0
            },
            dataType: 'json'
        }).success(function (data) {
            $('div#inventory_count_wrapper div#selected_inventory_count_wrapper').html(data.html);
        }).error(function (data) {
            modalTitle = 'Det oppstod en feil!';
            modalMessage = $.parseJSON(data.responseText).errors;
            modalAlertType = 'error';

            displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
        });
    });

    $('div#inventory_list_wrapper select#filter_by_year').change(function() {
        refreshList();
    });

    $(document).on('click', 'div#selected_inventory_count_wrapper div#pagination_wrapper li:not(.disabled) a ', function() {
        if ($(this).attr('aria-disabled') === 'true') {
            return false;
        }

        let pageNumber = $(this).attr('data-pagenumber');
        let inventoryCountId = selectedInventoryCountId;
        let totalProductsInInventoryCount = $('div#selected_inventory_count_wrapper div#pagination_wrapper input#number_of_products_in_inventory_count').val();
        const includeProductGroups = $('div#inventory_list_wrapper input#inventory_count_by_product_group').is(':checked');

        $.ajax({
            type: 'GET',
            url: ajaxPathGetInventoryCountProductsTableHtml,
            data: {
                data_pagenumber: pageNumber,
                inventory_count_id: inventoryCountId,
                total: totalProductsInInventoryCount,
                include_product_groups: includeProductGroups ? 1 : 0
            },
            dataType: 'json'
        }).success(function (data) {
            $('div#inventory_count_wrapper div#selected_inventory_count_wrapper').html(data.html);
            window.scrollTo(0,0);
        }).error(function (data) {
            modalTitle = 'Det oppstod en feil!';
            modalMessage = $.parseJSON(data.responseText).errors;
            modalAlertType = 'error';

            displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
        });

        return false;
    });

    // search by name

    $(document).on('keyup', 'div#inventory_list_wrapper input#inventory_search_input', function (e) {
        let key = e.which;
        let searchInput = $('div#inventory_list_wrapper input#inventory_search_input');

        if (key === 13 || $.trim(searchInput.val()) === '') {
            refreshList();
        }
    });

    $(document).on('click', 'div#inventory_list_wrapper button#inventory_search_button', function (e) {
        refreshList();
    });
});
